import React, { useContext, useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';
import ModalContext from '../../../shared/ModalContext/ModalContext';
import FullScreenLoader from '../../Common/FullScreenLoader';

export default function VerificationGuard({ children }) {
  const { user, isLoading, refreshUser } = useAuth();
  const { openModal, closeModal } = useContext(ModalContext);

  const handleVerificationSuccess = () => {
    setTimeout(() => {
      refreshUser();
      closeModal();
    }, 1500);
  };

  useEffect(() => {
    if (user && !user.isVerified) {
      openModal('VERIFICATION_MODAL', { onSuccess: handleVerificationSuccess });
    }
  }, [user, openModal]);


  if (isLoading) {
      return <FullScreenLoader />;
  }
  
  return children;
}